import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";

import { Form } from "@primevue/forms";

import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Paginator from "primevue/paginator";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import RadioButton from "primevue/radiobutton";
import AutoComplete from "primevue/autocomplete";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import IftaLabel from 'primevue/iftalabel';
import Password from 'primevue/password';
import Select from 'primevue/select';
import DatePicker from 'primevue/datepicker';
import Checkbox from 'primevue/checkbox';
import TextArea from 'primevue/textarea';
import FloatLabel from 'primevue/floatlabel';


export default (app) => {
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
    },
  });
  app.use(ToastService);

  // PrimeVue global components
  app.component("Toast", Toast);
  app.component("Dialog", Dialog);
  app.component("PrimeForm", Form);
  app.component("PrimeButton", Button);
  app.component("Paginator", Paginator);
  app.component("InputText", InputText);
  app.component("RadioButton", RadioButton);
  app.component("InputNumber", InputNumber);
  app.component("AutoComplete", AutoComplete);
  app.component("InputGroup", InputGroup);
  app.component("InputGroupAddon", InputGroupAddon);
  app.component("IftaLabel", IftaLabel);
  app.component("FloatLabel", FloatLabel);
  app.component("Password", Password);
  app.component("Select", Select);
  app.component("DatePicker", DatePicker);
  app.component("Checkbox", Checkbox);
  app.component("TextArea", TextArea);
};
